<div class="d-flex justify-content-between">
  <!-- Remove -->
  @if (editBtnVisible) {
    <button
      type="button"
      class="btn btn-outline-danger btn-sm ag_grid_row_btn form-control py-0"
      style="margin-left: 2px; margin-right: 2px"
      placement="left"
      (click)="revertClick()"
      >
      <i class="fa-solid fa-rotate-left"></i> Remove
    </button>
  }
  <!-- Select -->
  @if (editBtnVisible) {
    <button
      type="button"
      class="btn btn-outline-success btn-sm ag_grid_row_btn form-control py-0"
      style="margin-left: 2px; margin-right: 2px"
      placement="left"
      (click)="selectClick()"
      >
      <i class="fa-solid fa-thumbs-up"></i> Select
    </button>
  }
</div>
